// ── Static icon imports ────────────────────────────────────────────────────
// FrontBumper
// import CarnivoreFrontBumper from './Carnivore_FrontBumper.jpg';
import DefaultFrontBumper from './Default_FrontBumper.jpg';
import RAAQuadAlumFrontBumper from './RAA_Quad_Alum_FrontBumper.jpg';

// RearBumper
import DefaultRearBumper from './Default_RearBumper.jpg';
import RAAQuadAlumRearBumper from './RAA_Quad_Alum_RearBumper.jpg';
import RuggedRidgeRearBumper from './Rugged_Ridge_RearBumper.jpg';

// HoodCatcher
import DefaultHoodCatcher from './Default_HoodCatcher.jpg';
import HGOQuadHoodCatcher from './HGO_Quad_HoodCatcher.jpg';
import RuggedRidgeHoodCatcher from './Rugged_Ridge_HoodCatcher.jpg';

// Rims / Wheels
import DefaultRim from './Default_Rim_FL.jpg';
import WHLQuadHardrocRim from './WHL_Quad_Hardroc_Rim_FL.jpg';
import ZHEQuadCJRetroARRim from './ZHE_Quad_CJ_Retro_AR_Rim_FL.jpg';

// Tires
import DefaultTire from './Default_Tire_FL.jpg';
import WranglerTire from './Wrangler_Tire_FL.jpg';

// Fenders – Front (FL)
import DefaultFenderFL from './Defaut_Fender_FL.jpg';
import QuadratecBajaHDFenderFL from './Quadratec_Baja_HD_Fender_FL.jpg';
import RuggedRidgeMaxFenderFL from './Rugged_Ridge_Max_Fender_FL.jpg';

// Fenders – Rear (RL)
import DefaultFenderRL from './Defaut_Fender_RL.jpg';
import QuadratecBajaHDFenderRL from './Quadratec_Baja_HD_Fender_RL.jpg';
import RuggedRidgeMaxFenderRL from './Rugged_Ridge_Max_Fender_RL.jpg';

// Mirrors
import DefaultMirror from './Default_Mirror.jpg';
import QuadratecFactoryMirror from './Quadratec_Factory_Styling_Mirror.jpg';
import QuickReleaseMirrorRound from './Quick_Release_Mirror_Round.jpg';
import QuickReleaseMirrorRect from './Quick_Release_Mirror_Rectangle.jpg';

// Side Steps (jeep-type-specific)
import CarnivoreSideStep2D from './Carnivore_SideStep_2D.jpg';
import CarnivoreSideStep4D from './Carnivore_SideStep_4D.jpg';
import QR3SideStep2D from './Quadratec_QR3_SideStep_2D.jpg';
import QR3SideStep4D from './Quadratec_QR3_SideStep_4D.jpg';
import QR4SideStep2D from './Quadratec_QR4_SideStep_2D.jpg';
import QR4SideStep4D from './Quadratec_QR4_SideStep_4D.jpg';

// ── ID-based mapping (item.metadata._id) ───────────────────────────────────
// Keys match the metadata._id values used in the Threekit configuration.
export const iconById: Record<string, string> = {
  // HoodCatcher
  'hc-def': DefaultHoodCatcher,
  'hc-hgo': HGOQuadHoodCatcher,
  'hc-rr': RuggedRidgeHoodCatcher,

  // Fender – front
  'fender-def': DefaultFenderFL,

  // Fender – rear
  'rfender-def': DefaultFenderRL,
  '26031': QuadratecBajaHDFenderRL,   // QUADRATEC BAJA HD FENDER RL
  '25275': RuggedRidgeMaxFenderRL,     // RUGGED RIDGE MAX FENDER RL
  '25274': RuggedRidgeMaxFenderRL,     // Rugged Ridge HD Steel Tube Fenders – Rear JL (reuse)
  '26030': RuggedRidgeMaxFenderFL,     // Rugged Ridge Max-Terrain Rear Fender Flares JL

  // Rims / Wheels  – Hardrock family
  '14424': WHLQuadHardrocRim,
  '14425': WHLQuadHardrocRim,
  '14426': WHLQuadHardrocRim,
  '14427': WHLQuadHardrocRim,
  // CJ Retro family
  '22000': ZHEQuadCJRetroARRim,
  '215573': ZHEQuadCJRetroARRim,
  '215051': ZHEQuadCJRetroARRim,

  // Tires / Baja Boss family (M/T)
  '20469': WranglerTire,
  '20470': WranglerTire,
  '36213': WranglerTire,
  '36216': WranglerTire,
  '20461': WranglerTire,
  '20463': WranglerTire,
  '36193': WranglerTire,
  '36195': WranglerTire,

  // Front Bumpers – Quadratec Alum
  '23556': RAAQuadAlumFrontBumper,     // QUADRATEC WIDE ALUM FR BUMPER JK
  '23557': RAAQuadAlumFrontBumper,     // QUADRATEC STUBBY ALUM FR BUMPER JK

  // Rear Bumpers – Quadratec Alum
  '21996': RAAQuadAlumRearBumper,      // QUADRATEC WIDE ALUM REAR BUMPER JL
  '13765': RAAQuadAlumRearBumper,      // QUADRATEC QRC REAR BUMPER JK
  '260760': RAAQuadAlumRearBumper,     // QRC Rear Bumper for JT

  // Rear Bumpers – Rugged Ridge
  '21061': RuggedRidgeRearBumper,      // Rugged Ridge Spartan Full Width Rear
  '26000': RuggedRidgeRearBumper,      // Rugged Ridge Spartacus Rear JL
  '22728': RuggedRidgeRearBumper,      // Rugged Ridge HD Rear JL
  '28461': RuggedRidgeRearBumper,      // Rugged Ridge XOR Rear JL
  '28463': RuggedRidgeRearBumper,      // Rugged Ridge Arcus Rear JL

  // Mirrors
  'mirror-def': DefaultMirror,
  'mirror-factory': QuadratecFactoryMirror,
  'mirror-round': QuickReleaseMirrorRound,
  'mirror-rect': QuickReleaseMirrorRect,
};

// ── Jeep-type-specific icon map ─────────────────────────────────────────────
// For items whose icon depends on the jeep door count (2d / 4d).
export const iconByIdAndJeepType: Record<string, { '2d': string; '4d': string }> = {
  'ss-carnivore': { '2d': CarnivoreSideStep2D, '4d': CarnivoreSideStep4D },
  'ss-qr3':       { '2d': QR3SideStep2D,       '4d': QR3SideStep4D },
  'ss-qr4':       { '2d': QR4SideStep2D,       '4d': QR4SideStep4D },
};

// ── Label keyword-based fallback mapping ────────────────────────────────────────
// Used when _id is not found in the map above. Each entry is a tuple of
// [keyword (lowercase), icon]. First match wins.
export const iconByLabelKeyword: Array<[string, string]> = [
  // FrontBumper defaults / overrides
  // ['carnivore', CarnivoreFrontBumper],

  // Rear Bumper
  ['rugged ridge', RuggedRidgeRearBumper],
  ['rur', RuggedRidgeRearBumper],

  // Front Bumper – Quadratec alum
  ['quadratec wide alum', RAAQuadAlumFrontBumper],
  ['quadratec stubby alum', RAAQuadAlumFrontBumper],
  ['quadratec qrc', DefaultFrontBumper],

  // HoodCatcher – keep as extra safety net
  ['hgo quad hood', HGOQuadHoodCatcher],
  ['rugged ridge hood', RuggedRidgeHoodCatcher],

  // Wheels / Rims
  ['stock wheel', DefaultRim],
  ['hardrock', WHLQuadHardrocRim],
  ['morphic', WHLQuadHardrocRim],
  ['cj retro', ZHEQuadCJRetroARRim],
  ['recon wheel', WHLQuadHardrocRim],
  ['41 wheel', WHLQuadHardrocRim],
  ['moab wheel', WHLQuadHardrocRim],
  ['baja xtr', WHLQuadHardrocRim],
  ['rubicon xtreme', WHLQuadHardrocRim],

  // Tires
  ['baja boss', WranglerTire],
  ['wrangler', WranglerTire],

  // Fenders
  ['baja hd fender', QuadratecBajaHDFenderFL],
  ['max fender', RuggedRidgeMaxFenderFL],
  ['max terrain', RuggedRidgeMaxFenderFL],
  ['tube fender', RuggedRidgeMaxFenderFL],
];

// ── Default / "None" icons per attribute name ───────────────────────────────
// Keys must match the AttributesT values used in the Threekit configuration.
export const iconByAttributeNone: Record<string, string> = {
  'Front Bumper': DefaultFrontBumper,
  'Rear Bumper': DefaultRearBumper,
  'Hood Catcher': DefaultHoodCatcher,
  Mirror: DefaultMirror,
  Wheels: DefaultRim,
  Tire: DefaultTire,
  'Front Fender': DefaultFenderFL,
  'Rear Fender': DefaultFenderRL,
};

// ── Helper ──────────────────────────────────────────────────────────────────
/** Returns the best local icon for a Threekit attribute item, or `undefined`. */
export function getLocalIcon(
  id: string | undefined,
  label: string | undefined,
  attributeName?: string,
  jeepType: '2d' | '4d' = '4d'
): string | undefined {
  // 1. Jeep-type-specific ID match (e.g. Side Steps variants)
  if (id && iconByIdAndJeepType[id]) return iconByIdAndJeepType[id][jeepType];

  // 2. Exact ID match
  if (id && iconById[id]) return iconById[id];

  // 3. Label keyword scan
  if (label) {
    const lower = label.toLowerCase();
    for (const [keyword, icon] of iconByLabelKeyword) {
      if (lower.includes(keyword)) return icon;
    }
  }

  // 4. Attribute-level default (covers "None" and any unmatched item with a known attribute)
  if (attributeName && iconByAttributeNone[attributeName]) {
    return iconByAttributeNone[attributeName];
  }

  return undefined;
}
